/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Changelog,
} from '../models/index';
import {
    ChangelogFromJSON,
    ChangelogToJSON,
} from '../models/index';

/**
 * 
 */
export class ChangelogResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getMostRecentChangelog without sending the request
     */
    async getMostRecentChangelogRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/changelog/recent`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getMostRecentChangelogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Changelog>> {
        const requestOptions = await this.getMostRecentChangelogRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangelogFromJSON(jsonValue));
    }

    /**
     */
    async getMostRecentChangelog(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Changelog> {
        const response = await this.getMostRecentChangelogRaw(initOverrides);
        return await response.value();
    }

}
